import moment, {Moment} from 'moment-timezone'

import type {MomentRange} from '../types'

const startEndParamFormat = 'YYYY-MM-DDTHH'

export const convertToURLDatetime = (datetime: Moment, timezoneId: string): string =>
  datetime.clone().tz(timezoneId).format(startEndParamFormat)

export const toPixel = (value: number): string => `${value}px`

/**
 * Map a daily timeframe (any single day) to its corresponding month range
 * Returns the first day of the month to the first day of the next month
 */
export const mapDailyTimeframeToMonthly = (start: Moment, timezoneId: string): MomentRange => {
  return [
    start.clone().tz(timezoneId).startOf('month'),
    start.clone().tz(timezoneId).startOf('month').add(1, 'month')
  ]
}
